import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import SearchIcon from '../commons/icons/search_icon';

const Wrapper = styled.div`
  background: #f1f1f1;
  border-radius: 78px;
  width: 100%;
  display: flex;
  flex-direction: row;
  padding: 10px 20px 10px 15px;
  column-gap: 10px;
  box-sizing: border-box;
`;

const SearchInput = styled.input`
  display: flex;
  flex: 1;
  border: 0;
  outline: 0;
  background: #f1f1f1;
  font-weight: 400;
  font-size: 13px;
  line-height: 15px;
  &:focus {
    outline: none !important;
  }
`;

const SearchBar = ({ setSearchInput, onSearchHandler }) => {
  const [searchTerm, setSearchTerm] = useState(null);
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState(null);

  useEffect(() => {
    const delayTimer = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
      setSearchInput(searchTerm);
    }, 1000);

    return () => clearTimeout(delayTimer);
  }, [searchTerm]);

  useEffect(() => {
    if (searchTerm !== null) {
      onSearchHandler();
    }
  }, [debouncedSearchTerm]);

  return (
    <Wrapper>
      <SearchIcon size={30} />
      <SearchInput
        type="text"
        value={searchTerm}
        onChange={(e: { target: { value: any } }) =>
          setSearchTerm(e.target.value)
        }
        placeholder="Search articles, authors, categories..."
      />
    </Wrapper>
  );
};

export default SearchBar;
